export const messages = {
  en: {
    editCommunityPublicity: {
      title: 'Edit Publicity',
      publicityTitle: 'Publicity Title',
      publicityTitlePlaceholder: 'Required, please enter publicity title',
      publicityType: 'Publicity Type',
      publicityTypePlaceholder: 'Required, please select publicity type',
      headerImage: 'Header Image',
      activityContent: 'Activity Content',
      activityContentPlaceholder: 'Required, please enter activity content',
      validate: {
        titleRequired: 'Publicity title is required',
        typeRequired: 'Publicity type is required',
        imageRequired: 'Header image is required',
        contentRequired: 'Activity content is required'
      },
      message: {
        updateSuccess: 'Update publicity successfully',
        updateFailed: 'Update publicity failed'
      }
    },
    uploadImage: {
      message: {
        sizeLimit: 'Image size cannot exceed 2MB',
        uploadFailed: 'Upload image failed'
      }
    }
  },
  zh: {
    editCommunityPublicity: {
      title: '修改公示',
      publicityTitle: '公示标题',
      publicityTitlePlaceholder: '必填，请填写公示标题',
      publicityType: '公示类型',
      publicityTypePlaceholder: '必填，请选择公示类型',
      headerImage: '头部照片',
      activityContent: '活动内容',
      activityContentPlaceholder: '必填，请输入活动内容',
      validate: {
        titleRequired: '公示标题不能为空',
        typeRequired: '公示类型不能为空',
        imageRequired: '头部照片不能为空',
        contentRequired: '活动内容不能为空'
      },
      message: {
        updateSuccess: '修改公示成功',
        updateFailed: '修改公示失败'
      }
    },
    uploadImage: {
      message: {
        sizeLimit: '图片大小不能超过2MB',
uploadFailed: '图片上传失败'
      }
    }
  },
  'zh-TW': {
    editCommunityPublicity: {
      title: '修改公示',
      publicityTitle: '公示標題',
      publicityTitlePlaceholder: '必填，請填寫公示標題',
      publicityType: '公示類型',
      publicityTypePlaceholder: '必填，請選擇公示類型',
      headerImage: '頭部照片',
      activityContent: '活動內容',
      activityContentPlaceholder: '必填，請輸入活動內容',
      validate: {
        titleRequired: '公示標題不能為空',
        typeRequired: '公示類型不能為空',
        imageRequired: '頭部照片不能為空',
        contentRequired: '活動內容不能為空'
      },
      message: {
        updateSuccess: '修改公示成功',
        updateFailed: '修改公示失敗'
      }
    },
    uploadImage: {
      message: {
        sizeLimit: '圖片大小不能超過2MB',
        uploadFailed: '圖片上傳失敗'
      }
    }
  }
}